<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="fm_head"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii"><span class="right_1" epub:type="pagebreak" id="page_viii" title="viii">Contents</span></span></h2>
<p class="con" id="rcover"><a href="#/text/9780063009493_Cover#cover"><i>Cover</i></a></p>
<p class="con" id="rtitle"><a href="#/text/9780063009493_Titlepage#title"><i>Title Page</i></a></p>
<p class="con" id="r_idParaDest-1"><a href="#/text/9780063009493_Dedication#_idParaDest-1"><i>Dedication</i></a></p>
<p class="con1" id="r_idParaDest-3"><a href="#/text/9780063009493_Chapter_1#_idParaDest-3">1: The Secret</a></p>
<p class="con" id="r_idParaDest-5"><a href="#/text/9780063009493_Chapter_2#_idParaDest-5">2: Restarting</a></p>
<p class="con" id="r_idParaDest-7"><span href="#/text/9780063009493_Chapter_3#_idParaDest-7" title="Link target outside of Sample">3: Don’t Make a Fuss</span></p>
<p class="con" id="r_idParaDest-9"><span href="#/text/9780063009493_Chapter_4#_idParaDest-9" title="Link target outside of Sample">4: Wearing Someone Else’s Face</span></p>
<p class="con" id="r_idParaDest-11"><span href="#/text/9780063009493_Chapter_5#_idParaDest-11" title="Link target outside of Sample">5: My Lot</span></p>
<p class="con" id="r_idParaDest-13"><span href="#/text/9780063009493_Chapter_6#_idParaDest-13" title="Link target outside of Sample">6: City Is a Pity</span></p>
<p class="con" id="r_idParaDest-15"><span href="#/text/9780063009493_Chapter_7#_idParaDest-15" title="Link target outside of Sample">7: Did You Lose Your Comb?</span></p>
<p class="con" id="r_idParaDest-17"><span href="#/text/9780063009493_Chapter_8#_idParaDest-17" title="Link target outside of Sample">8: Shame</span></p>
<p class="con" id="r_idParaDest-19"><span href="#/text/9780063009493_Chapter_9#_idParaDest-19" title="Link target outside of Sample">9: Time Traveling</span></p>
<p class="con" id="r_idParaDest-21"><span href="#/text/9780063009493_Chapter_10#_idParaDest-21" title="Link target outside of Sample">10: Passing</span></p>
<p class="con1" id="r_idParaDest-23"><span href="#/text/9780063009493_Acknowledgments#_idParaDest-23" title="Link target outside of Sample"><i>Acknowledgments</i></span></p>
<p class="con" id="r_idParaDest-24"><span href="#/text/9780063009493_Notes#_idParaDest-24" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="con" id="r_idParaDest-25"><span href="#/text/About_the_Author#_idParaDest-25" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="con" id="r_idParaDest-26"><span href="#/text/9780063009493_Copyright#_idParaDest-26" title="Link target outside of Sample"><i>Copyright</i></span></p>
<p class="con" id="r_idParaDest-27"><span href="#/text/About_the_Publisher#_idParaDest-27" title="Link target outside of Sample"><i>About the Publisher</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780063009493_Contents.vue?3b3f5f33